import { render, staticRenderFns } from "./GewerbeVorversicherung.vue?vue&type=template&id=66daea9f&"
import script from "./GewerbeVorversicherung.vue?vue&type=script&lang=js&"
export * from "./GewerbeVorversicherung.vue?vue&type=script&lang=js&"
import style0 from "./GewerbeVorversicherung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRadio,VRadioGroup,VRow,VTextField})
